import apiHelper from "@/webapi/api_helper"
import logger from "@/util/logger"

// apis
const TARGET_API = 'configuration-service';
const API_INVENTORY = 'inventory';

// params
const PARAM_PROVIDER_ACCOUNT_ID = 'providerAccountId';
const PARAM_HOUSE_NUMBER = 'houseNumber';
const PARAM_ACCOUNT_NUMBER = 'accountNumber';

const LOG_TAG = 'configuration_service';
export default {
  getInventoryByAccountId(accountId, onResponseCb, onErrorCb) {
    const url = apiHelper.createUrl(TARGET_API, API_INVENTORY);
    const queryParams = apiHelper.createParams(
      PARAM_PROVIDER_ACCOUNT_ID, accountId
    );
    const urlWithParams = `${url}${queryParams}`

    logger.d(LOG_TAG, 'getInventoryByAccountId');
    apiHelper.apiGet(urlWithParams, onResponseCb, onErrorCb);
  },
  getInventoryByHouseAndAccountNumber(houseNum, accountNum, onResponseCb, onErrorCb) {
    const url = apiHelper.createUrl(TARGET_API, API_INVENTORY);
    const queryParams = apiHelper.createParams(
      PARAM_HOUSE_NUMBER, houseNum,
      PARAM_ACCOUNT_NUMBER, accountNum,
    );
    const urlWithParams = `${url}${queryParams}`

    logger.d(LOG_TAG, 'getInventoryByHouseAndAccountNumber');
    apiHelper.apiGet(urlWithParams, onResponseCb, onErrorCb);
  },
  addInventory(
      accountId, houseNum, accountNum,
      hwKey, macAddr, serialNum,
      onResponseCb, onErrorCb) {
    const url = apiHelper.createUrl(TARGET_API, API_INVENTORY);
    let queryParams;
    if (accountId) {
      queryParams = apiHelper.createParams(
        PARAM_PROVIDER_ACCOUNT_ID, accountId
      );
    } else {
      queryParams = apiHelper.createParams(
        PARAM_HOUSE_NUMBER, houseNum,
        PARAM_ACCOUNT_NUMBER, accountNum,
      );
    }

    const urlWithParams = `${url}${queryParams}`
    const payload = {
      'hardwareKey': hwKey,
      'macAddress': macAddr,
      'serialNumber': serialNum
    };
    logger.d(LOG_TAG, 'addInventory');
    apiHelper.apiPost(urlWithParams, payload, onResponseCb, onErrorCb);
  },
  removeInventory(
      accountId, houseNum, accountNum,
      itemId,
      onResponseCb, onErrorCb) {
    const url = apiHelper.createUrl(TARGET_API, API_INVENTORY, itemId);
    let queryParams;
    if (accountId) {
      queryParams = apiHelper.createParams(
        PARAM_PROVIDER_ACCOUNT_ID, accountId
      );
    } else {
      queryParams = apiHelper.createParams(
        PARAM_HOUSE_NUMBER, houseNum,
        PARAM_ACCOUNT_NUMBER, accountNum,
      );
    }
    const urlWithParams = `${url}${queryParams}`

    logger.d(LOG_TAG, 'removeInventory');
    apiHelper.apiDelete(urlWithParams, onResponseCb, onErrorCb);
  },
};

